import React from 'react';
import clsx from 'clsx';

import { MilestoneEventGroup } from '../hooks/TrackingPanel.hooks';
import ScanEvent from '../ScanEvent/ScanEvent';
import { PAST_MILESTONE_NAME_TEST_ID, PAST_MILESTONE_TEST_ID } from './PastMilestones.test-ids';

import styles from './PastMilestones.module.scss';

interface PastMilestonesProp {
  milestones: MilestoneEventGroup[];
  isDelivered?: boolean;
}

const PastMilestones: React.FC<PastMilestonesProp> = ({ milestones, isDelivered = false }) => {
  const tramTrackClasses = clsx(styles.tramTrack, {
    [styles.green]: isDelivered,
  });

  return (
    <ul className={styles.pastMilestoneWrapper} data-testid={PAST_MILESTONE_TEST_ID}>
      {milestones?.map((milestone, i) => {
        return (
          <React.Fragment key={i}>
            <div className={styles.pastMilestone}>
              <span className={styles.milestoneStop} />
              <p className={styles.milestoneName} key={i} data-testid={PAST_MILESTONE_NAME_TEST_ID}>
                <span className='sr-only'>Past milestone:&nbsp;</span>
                {milestone.milestone}
              </p>
            </div>
            <div className={styles.pastMilestoneEvent}>
              {milestone.events?.map((e, index) => {
                return <ScanEvent event={e} key={e.eventCode + index} />;
              })}
              <div className={styles.divider} />
            </div>
          </React.Fragment>
        );
      })}
      <div className={tramTrackClasses} />
    </ul>
  );
};

export default PastMilestones;
